((w, d, fdl, h) => {
	const pushState = h.pushState;
	const youTubeRegex = RegExp(/(?:https?:\/\/)?(?:www\.)?(?:youtube\.com\/(?:[^\/]+\/.+\/|(?:v|e(?:mbed)?)\/|.*[?&]v=)|youtu\.be\/)([^"&?\/ ]{11})/i);

	// default cookie compliance script
	function cookieCompliance() {
		if (document.querySelector('.farlo-ui-biscuit-banner__button')) {
			document.querySelector('.farlo-ui-biscuit-banner__button').addEventListener('click', (e) => {
				e.preventDefault();

				e.target.closest('.farlo-ui-biscuit-banner').classList.add('farlo-ui-biscuit-banner--hide');

				window._farlo.storage.set('cookieCompliance', 'true', 'cookie');
			});
		}

		if (document.querySelector('.farlo-ui-biscuit-banner__button--close')) {
			document.querySelector('.farlo-ui-biscuit-banner__button--close').addEventListener('click', (e) => {
				e.preventDefault();

				e.target.closest('.farlo-ui-biscuit-banner').classList.add('farlo-ui-biscuit-banner--hide');
			});
		}
	}

	// default navicon
	function navicon() {
		document.querySelector('.site-navigation__navicon').addEventListener('click', (e) => {
			e.preventDefault();
			e.currentTarget.classList.toggle('site-navigation__navicon--active');
			document.querySelector('.site-navigation').classList.toggle('site-navigation__nav--active');
			document.body.classList.toggle('site-navigation__nav--open');
		});
	}

	// lightbox
	function farloUiLightbox(elem, div) {
		if (elem.querySelector('.wp-block-image')) {
			elem.querySelector('.wp-block-image').addEventListener('click', function(e) {
				const clonedEmbed = e.currentTarget.closest('.wp-block-group').querySelector('.wp-block-embed').cloneNode(true);
				document.body.classList.add('body--farlo-ui-lightbox-open');
				div.querySelector('.farlo-ui-lightbox__inner-content').appendChild(clonedEmbed);
				div.classList.add('farlo-ui-lightbox--active');
			});
		}

		if (elem.nextElementSibling && elem.nextElementSibling.value) {
			elem.addEventListener('click', function(e) {
				document.body.classList.add('body--farlo-ui-lightbox-open');
				div.querySelector('.farlo-ui-lightbox__inner-content').classList.add('dynamic');
				if (e.target.nextElementSibling && e.target.nextElementSibling.value) {
					div.querySelector('.farlo-ui-lightbox__inner-content').innerHTML = e.target.nextElementSibling.value;
				}
				div.classList.add('farlo-ui-lightbox--active');
			});
		}

		if (elem.querySelector('a[href*="youtu.be"]')) {
			elem.querySelector('a[href*="youtu.be"]').addEventListener('click', function(e) {
				e.preventDefault();
				document.body.classList.add('body--farlo-ui-lightbox-open');
				div.querySelector('.farlo-ui-lightbox__inner-content').innerHTML = '<iframe class="farlo-ui-lightbox__inner-content-iframe" src="https://www.youtube-nocookie.com/embed/' + e.target.href.match(youTubeRegex)[ 1 ] + '" frameborder="0" allow="autoplay; encrypted-media" allowfullscreen></iframe>';
				div.classList.add('farlo-ui-lightbox--active');
			});
		}

		if (div.querySelector('.farlo-ui-lightbox__button-close')) {
			div.querySelector('.farlo-ui-lightbox__button-close').addEventListener('click', function(e) {
				e.preventDefault();
				document.body.classList.remove('body--farlo-ui-lightbox-open');
				e.currentTarget.closest('.farlo-ui-lightbox').classList.remove('farlo-ui-lightbox--active');
				if (div.querySelector('.farlo-ui-lightbox__inner-content.dynamic')) {
					div.querySelector('.farlo-ui-lightbox__inner-content').classList.remove('dynamic');
				}
				div.querySelector('.farlo-ui-lightbox__inner-content').innerHTML = '';

				if (elem.classList.contains('site-geo-targeting')) {
					window._farlo.storage.set('geotargeted', 'true', 'cookie');
				}
			});
		}

		if (elem.classList.contains('site-geo-targeting')) {
			elem.remove();
			document.body.classList.add('body--farlo-ui-lightbox-open');
			div.querySelector('.farlo-ui-lightbox__inner-content').classList.add('dynamic');
			div.querySelector('.farlo-ui-lightbox__inner-content').classList.add('geo-targeted');
			elem.style.display = 'none';
			div.querySelector('.farlo-ui-lightbox__inner-content').innerHTML = elem.innerHTML;
			div.classList.add('farlo-ui-lightbox--active');
		}
	}

	// 222 time
	function twoTwoTwoTime() {
		let currentDate;
		let currentHours;
		let currentMinutes;
		let currentSeconds;
		const constants = [[2, 3, 5, 6, 7, 8, 9, 0], [1, 2, 3, 4, 7, 8, 9, 0], [1, 3, 4, 5, 6, 7, 8, 9, 0], [2, 3, 5, 6, 8, 0], [6, 8, 2, 0], [4, 5, 6, 8, 9, 0], [2, 3, 4, 5, 6, 8, 9]];

		const hours = [];
		const minutes = [];
		const seconds = [];

		let flips = 20;

		function updateDate() {
			currentDate = new Date();
			currentHours = currentDate.getHours();
			if (currentHours < 10) {
				currentHours = '0' + currentHours;
			}
			currentMinutes = currentDate.getMinutes();
			if (currentMinutes < 10) {
				currentMinutes = '0' + currentMinutes;
			}
			currentSeconds = currentDate.getSeconds();
			if (currentSeconds < 10) {
				currentSeconds = '0' + currentSeconds;
			}
		}

		function splitDigits(stringVal, array) {
			const tempString = stringVal.toString();
			array.length = 0;
			for (let i = 0; i < tempString.length; i += 1) {
				array.push(+tempString.charAt(i));
			}
		}

		function checkVal(val, array) {
			for (let k = 0; k < array.length; k += 1) {
				if (val === array[ k ]) {
					return true;
				}
			}
			return false;
		}

		function turnOn(elem) {
			if (document.querySelector(elem)) {
				document.querySelector(elem).classList.add('on');
			}
		}

		function turnOff(elem) {
			if (document.querySelector(elem)) {
				document.querySelector(elem).classList.remove('on');
			}
		}

		function printDigits(array, elem) {
			for (let count = 0; count < array.length; count += 1) {
				for (let segmentCount = 0; segmentCount < 7; segmentCount += 1) {
					if (checkVal(array[ count ], constants[ segmentCount ])) {
						turnOn(elem + (count + 1) + ' div:nth-of-type(' + (segmentCount + 1) + ')');
					} else {
						turnOff(elem + (count + 1) + ' div:nth-of-type(' + (segmentCount + 1) + ')');
					}
				}
			}
		}

		function flipOut() {
			printDigits([Math.floor(Math.random() * 10), Math.floor(Math.random() * 10)], '.m');
			printDigits([Math.floor(Math.random() * 10), Math.floor(Math.random() * 10)], '.h');

			flips = flips - 1;

			if (flips <= 0) {
				printDigits([2, 2], '.m');
				printDigits([0, 2], '.h');
				document.getElementById('time-feature').classList.add('time-complete');
				return Promise.resolve(true);
			}

			return new Promise((resolve) => {
				setTimeout(function() {
					resolve(
						requestAnimationFrame(flipOut)
					);
				}, 50);
			});
		}

		setInterval(function() {
			document.getElementById('time-feature').querySelectorAll('.dot').forEach(function(elem) {
				elem.classList.toggle('on');
			});
			document.getElementById('time-feature').classList.toggle('on');
		}, 1000);

		const realTime = setInterval(function() {
			updateDate();
			splitDigits(currentSeconds, seconds);
			printDigits(seconds, '.s');

			splitDigits(currentMinutes, minutes);
			printDigits(minutes, '.m');

			splitDigits(currentHours, hours);
			printDigits(hours, '.h');
		}, 1000);

		setTimeout(function() {
			clearInterval(realTime);
			updateDate();
			flipOut();
		}, 4000);
	}

	function mediaGallery(elem) {
		if (elem.classList.contains('columns-1') && !elem.classList.contains('cast-gallery')) {
			const thumbnails = document.createElement('div');
			const thumbnailsInner = document.createElement('div');
			const images = elem.children;
			const clonedThumbnailImages = [];

			elem.classList.add('wp-block-gallery__highlighted');

			thumbnails.classList.add('wp-block-gallery__thumbnails');
			thumbnailsInner.classList.add('wp-block-gallery__thumbnails-inner');

			_farlo.helpers.elements.wrapElement(elem, document.createElement('div'), 'wp-block-gallery-container');

			thumbnails.appendChild(thumbnailsInner);
			document.querySelector('.wp-block-gallery-container').appendChild(thumbnails);

			for (let i = 0; i < images.length; i += 1) {
				clonedThumbnailImages.push(images[ i ].cloneNode(true));
			}

			for (let i = 0; i < clonedThumbnailImages.length; i += 1) {
				thumbnailsInner.append(clonedThumbnailImages[ i ]);
			}

			elem.setAttribute('data-center', true);
			elem.setAttribute('data-controls', true);
			elem.setAttribute('data-navContainer', '.wp-block-gallery__thumbnails-inner');
			elem.setAttribute('data-navAsThumbnails', true);
			elem.setAttribute('farlo-ui', 'carousel');

			thumbnailsInner.style.width = (clonedThumbnailImages.length * thumbnailsInner.children[ 0 ].offsetWidth) + 'px';
		} else {
			_farlo.helpers.elements.wrapElement(elem, document.createElement('div'), 'wp-block-gallery-container,wp-block-gallery-container__cast');
			elem.setAttribute('data-mode', 'gallery');
			elem.setAttribute('data-autoplay', true);
			elem.setAttribute('data-autoplayTimeout', 3000);
			elem.setAttribute('data-center', false);
			elem.setAttribute('data-controls', false);
			elem.setAttribute('data-nav', false);
			elem.setAttribute('farlo-ui', 'carousel');
		}
	}

	function geoTargeting() {
		const targets = document.querySelectorAll('.site-geo-targeting__button');

		targets.forEach(function(elem) {
			elem.addEventListener('click', function(e) {
				e.stopImmediatePropagation();

				window._farlo.storage.set('geotargeted', 'true', 'cookie');

				window.location.href = e.target.dataset.href;
			});
		});
	}

	history.pushState = function(state) {
		if (typeof history.onpushstate === 'function') {
			history.onpushstate({ state });
		}
		return pushState.apply(history, arguments);
	};

	document.addEventListener('DOMContentLoaded', () => {
		const lightboxEmbed = document.querySelectorAll('.site-video-embed-group, .farlo-ui-lightbox__toggle, .site-geo-targeting');
		const galleries = document.querySelectorAll('.wp-block-gallery');
		let div;
		let divInner;
		let divInnerContent;
		let divClose;

		if (document.querySelector('.site-navigation__navicon')) {
			navicon();
		}

		if (document.querySelector('.farlo-ui-biscuit-banner')) {
			cookieCompliance();
		}

		if (document.getElementById('time-feature')) {
			twoTwoTwoTime();
		}

		galleries.forEach(function(elem) {
			mediaGallery(elem);
		});

		if (lightboxEmbed.length > 0) {
			div = document.createElement('div');
			divInner = document.createElement('div');
			divInnerContent = document.createElement('div');
			divClose = document.createElement('button');
			div.className = 'farlo-ui-lightbox';
			divInner.className = 'farlo-ui-lightbox__inner';
			divInnerContent.className = 'farlo-ui-lightbox__inner-content';
			divClose.className = 'farlo-ui-lightbox__button-close';

			document.body.appendChild(div);
			document.querySelector('.farlo-ui-lightbox').appendChild(divInner);
			document.querySelector('.farlo-ui-lightbox__inner').appendChild(divInnerContent);
			document.querySelector('.farlo-ui-lightbox__inner').appendChild(divClose);

			lightboxEmbed.forEach(function(elem) {
				farloUiLightbox(elem, div);
			});
		}

		document.documentElement.classList.add(window._farlo.browser.init());

		if (document.querySelector('.site-geo-targeting__buttons')) {
			geoTargeting();
		}
	});

	window.addEventListener('load', function() {
		window._farloUi.init();
	});

	let _ukds_mc_form = null;
	const _ukds_mc_id = 'tour-222';
	function _farloUiMcForm(e, _city) {
		if (typeof e !== 'undefined') {
			e.preventDefault();
		}
		_city = (typeof _city === 'undefined' ? '' : _city);
		const _elem = document.querySelector('#' + _ukds_mc_id);

		_elem.querySelectorAll("[data-label='CITY']").forEach((_sel) => {
			if (document.documentElement.classList.contains('australia')) {
				_sel.innerText = (_city === '' ? 'Melbourne' : _city);
			} else if (document.documentElement.classList.contains('dublin')) {
				_sel.innerText = (_city === '' ? 'Dublin' : _city);
			} else if (document.documentElement.classList.contains('new-york')) {
				_sel.innerText = (_city === '' ? 'New York' : _city);
			} else {
				_sel.innerText = (_city === '' ? 'your city' : _city);
			}
		});

		_elem.querySelectorAll('.ukds-mc-header').forEach((_sel) => {
			if (document.documentElement.classList.contains('dublin') && _sel) {
				_sel.querySelector('p').textContent = 'Be the first to hear when tickets for Dublin go on sale.';
			}
		});

		_elem.querySelectorAll('.ukds-mc-check-label').forEach((_sel) => {
			if (document.documentElement.classList.contains('australia') || document.documentElement.classList.contains('new-york')) {
				_sel.textContent = 'I consent to being contacted by the Producers of 2:22 - A Ghost Story.';
			}
		});

		_elem.querySelectorAll('label[for="CITY"]').forEach((_sel) => {
			if (document.documentElement.classList.contains('new-york')) {
				_sel.querySelector('.ukds-mc-text-label').textContent = 'State/City';
			}
		});

		_elem.querySelectorAll('input').forEach((_inp) => {
			_inp.classList.remove('invalid');

			if (document.documentElement.classList.contains('australia')) {
				if (_inp.getAttribute('id') === 'TARGET') {
					_inp.value = 'Australia';
					_inp.required = false;
				}
			}

			if (document.documentElement.classList.contains('dublin')) {
				if (_inp.getAttribute('id') === 'TARGET') {
					_inp.value = 'Dublin';
					_inp.required = false;
				}
			}

			if (document.documentElement.classList.contains('new-york')) {
				if (_inp.getAttribute('id') === 'TARGET') {
					_inp.value = 'Broadway';
					_inp.required = false;
				}
			}
		});

		if (_ukds_mc_form) {
			document.querySelector('#CITY').value = _city;
			document.querySelector('#CITY').required = false;

			_ukds_mc_form.toggleForm();
		} else {
			_ukds_mc_form = new UKDS_MC({
				'formId': _ukds_mc_id,
				'initData': {
					'CITY': _city
				},
				'validateFirst': false
			});
		}
	}

	document.querySelectorAll('[href="#tickx-signup"], [data-trigger="tickx-onboarding"]').forEach((btn) => {
		btn.addEventListener('click', (e) => {
			e.preventDefault();
			e.stopImmediatePropagation();
			if (typeof tx !== 'undefined') {
				tx({
					widgetId: 'GhostStory222',
					configId: '_DJXNNtx2',
					type: 'onboarding'
				});
			}
		});
	});

	if (document.documentElement.classList.contains('london')) {
		if (document.querySelector('.site-logo')) {
			document.querySelector('.site-logo').addEventListener('click', (e) => {
				if (e.currentTarget !== null) {
					window.location.href = '/';
				}
			});
		}
	}

	document.querySelectorAll('[data-signup]').forEach((btn) => {
		btn.addEventListener('click', (e) => {
			_farloUiMcForm(e, btn.dataset.signup);
		});
	});

	if (document.querySelector('#mailing-list-toggle')) {
		document.querySelector('#mailing-list-toggle').addEventListener('click', (e) => {
			_farloUiMcForm(e);
		});
	}

	document.querySelectorAll('.toggle-ukds-form').forEach((_sel) => {
		_sel.querySelector('a').addEventListener('click', (e) => {
			_farloUiMcForm(e);
		});
	});

	if (typeof navigator !== 'undefined') {
		navigator.serviceWorker.getRegistrations().then(function(registrations) {
			for (const registration of registrations) {
				registration.unregister();
			}
		});
	}
})(window, document, typeof dataLayer !== 'undefined' ? dataLayer : [], history);

